/** Resolved value of the early session request; mirrors the part of an axios response the app reads. */
export type EarlySessionResponse = { data: unknown };

interface EarlySessionWindow {
  __earlySession?: Promise<EarlySessionResponse>;
}

/**
 * Hands over the session request that src/earlySession.ts started while the app bundle was still
 * downloading, or `undefined` when there is none (no stored token, or it was already taken). It is
 * single-use: later session refreshes must hit the server again.
 */
export function takeEarlySession(): Promise<EarlySessionResponse> | undefined {
  if (typeof window === 'undefined') return undefined;
  const holder = window as unknown as EarlySessionWindow;
  const request = holder.__earlySession;
  delete holder.__earlySession;
  return request;
}
